/**
 * @file 接口数据格式化
 * @author quda
 */
import {SELF_MARK} from '../constant/MarkRank.js';

export function formatMark(markList) {
    const likedInfo = {};
    const marksInfo =  markList.map(mark => {
        if (mark.markid) {
            likedInfo[mark.markid] = mark.isliked;
        }

        const {
            markid,
            content,
            richcontent,
            x,
            y,
            z,
            srclogo: headImg,
            srcname: nickname,
            isliked,
            isself,
            likenum,
            status,
            position: markLocation,
            c_time: createdTime,
            type,
            pid
        } = mark;

        const heading = Number(mark.heading);
        const pitch =  Number(mark.pitch);

        return {
            markid,
            content,
            richcontent,
            heading,
            pitch,
            x,
            y,
            z,
            type,
            headImg,
            nickname,
            isliked,
            isself,
            status,
            markLocation,
            likenum: isliked ? parseInt(likenum, 10) - 1 : parseInt(likenum, 10),
            createdTime,
            rank: mark.isself ? SELF_MARK : 0,
            pid
        };
    });

    return {
        likedInfo,
        marksInfo
    };
}
export function formatReplyList(replyList) {
    const replyLikedInfo = {};
    const replyInfo = replyList.map(reply => {
        if (reply.id) {
            replyLikedInfo[reply.id] = reply.isliked;
        }
        const {
            mark_id: markid,
            parent_id: parentid,
            id,
            content,
            srclogo: headImg,
            srcname: nickname,
            isliked,
            isself,
            like_count: likenum,
            replied_name: replyName,
            c_time: createdTime,
            m_time: modifiedTime,
            status,
            up_floor_id
        } = reply;
        return {
            markid,
            parentid,
            id,
            content,
            headImg,
            nickname,
            isliked,
            isself,
            likenum: isliked ? parseInt(likenum, 10) - 1 : parseInt(likenum, 10),
            replyName,
            createdTime,
            modifiedTime,
            status,
            up_floor_id
        };
    });
    return {
        replyLikedInfo,
        replies: replyInfo
    };
}

export function formatMessageList(replyList) {
    const replyInfo = replyList.map(reply => {
        const {
            markid,
            content,
            srclogo: headImg,
            srcname: nickname,
            isliked,
            isself,
            likenum,
            richcontent,
            c_time: createdTime,
            m_time: modifiedTime,
            replynum
        } = reply;
        return {
            markid,
            content,
            headImg,
            nickname,
            isliked,
            isself,
            richcontent,
            likenum: isliked ? parseInt(likenum, 10) - 1 : parseInt(likenum, 10),
            createdTime,
            modifiedTime,
            replynum
        };
    });
    return {
        replies: replyInfo
    };
}

export function formatTabList(tabList) {
    // 最大索引用来确认是否发统计
    let maxIndex = 0;
    // 全量数据的索引
    let listCurIndex = 0;
    // 删除过几次请求回来的数据
    let deleteNum = 0;
    // swiper实时渲染的数组
    let renderList = [];
    let swiperListAcNum = 0;
    // 全量数据数组
    let panoList = [];
    let finalList;
    if (tabList.length) {
        finalList = tabList.map(tabItem => {
            if (!tabItem.child_list) {
                tabItem.child_list = [];
            }
            return {
                ...tabItem,
                maxIndex,
                listCurIndex,
                panoList,
                deleteNum,
                renderList,
                swiperListAcNum
            };
        });
    }
    else {
        finalList = [
            {
                show_name: '推荐',
                name: '',
                icon: '',
                upd_time: 0,
                maxIndex,
                listCurIndex,
                panoList,
                deleteNum,
                renderList,
                swiperListAcNum
            }
        ];
    }
    return finalList;
}

// 数组去重
export function removeRepeation(arrs) {
    let map = new Map();
    for (let item of arrs) {
        if (!map.has(item.pid)) {
            map.set(item.pid, item);
        }
    }
    let newArr = [...map.values()];
    return newArr;
}

// 数组去重
// arr1为原始数据
// arr2为服务返回数据数据
// num 去重末尾几位重复的
export function removeLastRepeation(arr1, arr2, num) {
    if (!arr1.length) {
        return arr2;
    }
    // let lastOne = arr1[arr1.length - 1];
    // let lastTwo = arr1[arr1.length - 2];
    let copyArr = arr2.concat();
    // let newArr = arr2.filter(item => item.pid !== lastOne.pid && item.pid !== lastTwo.pid);
    copyArr.splice(0, num);

    return copyArr;
}

export function formatAlbumList(list) {
    const thumb_url = 'https://mapsv0.bdimg.com/?qt=pr3d&fovy=80&quality=80&width=300&height=400';
    const result = list.map(item => {
        let url = `${thumb_url}&panoid=${item.pid}`;
        if (typeof item.heading !== 'undefined') {
            url += `&heading=${item.heading}`;
        }
        if (typeof item.pitch !== 'undefined') {
            url += `&pitch=${item.pitch}`;
        }
        item.imgurl = url;
        return item;
    });
    return result;
}

// 根据pid去重(推荐下主题卡除外，pid是重复的)
export function newRemoveRepeation(arr) {
    let newArr = [];
    let obj = {};
    for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        if (!obj[item.pid] || item.tab_type === 12) {
            newArr.push(item);
            obj[item.pid] = true;
        }
    }
    return newArr;
}